import * as React from 'react';

import { useFooterOffset, useNavigationItems } from './hooks';
import { MobileBottomNavigation } from '../../components/MobileBottomNavigation';
import { useMobileBottomNavigation } from '../../hooks/useMobileBottomNavigationEnabled';

/**
 * Компонент боттом навигации для мобвеба
 *
 * TODO: после эксперимента перенести в микрофронт и рендерить на конкретных страницах
 */
export const MobileBottomNavigationContainer: React.FC = () => {
  const items = useNavigationItems();

  const isMobileBottomNavigationEnabled = useMobileBottomNavigation();

  useFooterOffset(isMobileBottomNavigationEnabled);

  if (!isMobileBottomNavigationEnabled) {
    return null;
  }

  return <MobileBottomNavigation items={items} />;
};
